module.exports = __webpack_public_path__ + "static/category-sport-5248c631a2534cbcb6d4c139fd816103.jpg";